export enum DrawingFeatureTypeEnum {
  POINT = 'POINT',
  LINE = 'LINE',
  POLYGON = 'POLYGON',
  CIRCLE = 'CIRCLE',
  CIRCLE_SPECIFIED_RADIUS = 'CIRCLE_SPECIFIED_RADIUS',
  LABEL = 'LABEL',
  ELLIPSE = 'ELLIPSE',
  RECTANGLE = 'RECTANGLE',
  RECTANGLE_SPECIFIED_SIZE = 'RECTANGLE_SPECIFIED_SIZE',
  SQUARE = 'SQUARE',
  SQUARE_SPECIFIED_LENGTH = 'SQUARE_SPECIFIED_LENGTH',
  STAR = 'STAR',
  IMAGE = 'IMAGE',
}
